import { DownloadFileDto } from '@sr/dto';
export interface FormData {
    companies: number[];
    media: number[];
    mainFile: DownloadFileDto[];
    extraFiles: DownloadFileDto[]
}

export const emptyValues: FormData = {
  companies: [],
  media: [],
  mainFile: [],
  extraFiles: []
};
